import {Construtor} from './construtor';

export class PercentualPontoFisico implements Construtor<PercentualPontoFisico> {

  public nomePontoFisico: string;
  public percentual: number;

  constructor(object?: any) {
    if (object !== undefined) {
      if (object instanceof (PercentualPontoFisico)) {
        this.copyObject(object);
      } else {
        this.parseFromJson(object);
      }

      if (!this.modeloCompleto()) {
        return null;
      }
    }
  }

  parseFromJson(pencentualPontoFisico: any): void {
    this.nomePontoFisico = pencentualPontoFisico.nomePontoFisico;
    this.percentual = pencentualPontoFisico.percentual;
  }

  copyObject(pencentualPontoFisico: PercentualPontoFisico): void {
    this.nomePontoFisico = pencentualPontoFisico.nomePontoFisico;
    this.percentual = pencentualPontoFisico.percentual;
  }

  modeloCompleto(): boolean {
    return this.nomePontoFisico !== undefined && this.percentual !== undefined;
  }

  getNewInstance(object?: any): PercentualPontoFisico {
    return new PercentualPontoFisico(object);
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/modelos/percentual-ponto-fisico.ts